
import Loading from "../components/Loading.vue";
export default {
  components: {
    Loading,
  },
  props: {},
};
